import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/charging_package_settlement_rules',
  component: Management,
  redirect: '/charging_package_settlement_rules/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/charging_package_settlement_rules/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listChargingPackageSettlementRules
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/charging_package_settlement_rules/ListTable'),
          meta: {
            auth: Auth.listChargingPackageSettlementRules,
            tabName: 'all'
          }
        },
        {
          path: 'enabled',
          component: () => import('@/views/charging_package_settlement_rules/ListTable'),
          meta: {
            auth: Auth.listChargingPackageSettlementRules,
            tabName: 'enabled'
          }
        },
        {
          path: 'disabled',
          component: () => import('@/views/charging_package_settlement_rules/ListTable'),
          meta: {
            auth: Auth.listChargingPackageSettlementRules,
            tabName: 'disabled'
          }
        }
      ]
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/charging_package_settlement_rules/New'),
      meta: {
        auth: Auth.createChargingPackageSettlementRule
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/charging_package_settlement_rules/Edit'),
      meta: {
        auth: Auth.updateChargingPackageSettlementRule
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/charging_package_settlement_rules/DetailLayout'),
      meta: {
        auth: Auth.showChargingPackageSettlementRule
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/charging_package_settlement_rules/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showChargingPackageSettlementRule
          }
        },
        // 站结算记录
        {
          path: 'ev_charging_station_settlements',
          component: () => import('@/views/charging_package_settlement_rules/details/EvChargingStationSettlements'),
          meta: {
            tabName: 'ev_charging_station_settlements', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.listEvChargingStationSettlements
          }
        },
        // 充电包结算记录
        {
          path: 'charging_package_settlement',
          component: () => import('@/views/charging_package_settlement_rules/details/ChargingPackageSettlements'),
          meta: {
            tabName: 'charging_package_settlements', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.listChargingPackageSettlements
          }
        }
      ]
    }
  ]
}
